import React, { Component } from 'react';

import './attribution.less';

const attributionText = "Catalog enrichment powered by NoveList, with additional content provided by Baker & Taylor.";

class Attribution extends Component
{
	render() {
		return (<div className={"attribution"}>{attributionText}</div>);
	}
}

export default Attribution;
export { attributionText }



// WEBPACK FOOTER //
// ./src/react/views/attribution/Attribution.jsx